export default {
    LOAD_YOUTUBE_APP(state, youtube){
        state.items = youtube
    }
}